// Manager = STATE + CONTROLLER

// MVC:  Action -> Controller -> Model -> Render

import DataManager from "./manager/data"
import GList_Filters from "./manager/filters"
import SearchManager from "./manager/search"
import SortByManager from "./manager/sort-by"
import GroupByManager from "./manager/group-by"
import ListColumnsManager from "./manager/columns-manager/columns"
import SelectionManager from "./manager/selection"
// @ts-ignore
import DNDManager from "../dnd/managers/dnd-manager"
import {findDOMNode} from "react-dom"
import GListDefaultTitleFieldComponent from "./render/title-field-component/title-field-component"
import {GlistWidthMode} from "./manager/columns-manager/const"
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {GlistConfig} from "./types/glist-config";
import FieldProto from "../../fields3/proto/field-proto";
import {GlistHeaderMode} from "./const";
import {GListSettings} from "./@types";

const debug = false
// const debug = "GenericListModule"

export default class GenericListModule {


    // Managers
    public filters!            : GList_Filters
    public search!             : SearchManager
    public sortBy!             : SortByManager
    public selection!          : SelectionManager
    public data!               : DataManager
    public columns!            : ListColumnsManager
    public groupBy!            : any //GroupByManager | null

    fields                      : FieldsCollection

    public widthMode            : GlistWidthMode
    public config               : GlistConfig // any

    defaultRenderMethod     : string
    titleSticky             : boolean
    headerMode              : GlistHeaderMode
    renderTitleComponent    : any
    canChangeColumnsOrder   : boolean

    skin                    : any
    headerDndManager        : any
    dndManager              : any
    components              : any


    public skinName               : string

    // init properties
    public canAddColumns          : boolean
    public canAddCustomColumns    : boolean
    public canResizeColumns       : boolean
    public canDndColumns          : boolean
    public canDndItems            : boolean
    public canSort                : boolean
    public headerMoreButton       : boolean
    public titleColumnReorder     : boolean


    public renderCellComponent    : any

    public noItemsMessage         : string
    public noItemsRenderComponent : string

    public groupHoverId?          : string
    public parentWidth?           : number

    public hasAggregation         : boolean = false

    public displayGlistBottom     : boolean = true    // stupid in cards on pokazivaetsya vsegda no inogda nado vikluchat'


    // not in use think about it
    // COLUMN_TYPE_FIELD   = 'field';
    // COLUMN_TYPE_ACTIONS = 'actions'

    constructor(fields: FieldsCollection, config:GlistConfig) {

        debug && console.log(debug,"constructor()")

        this.config = config;
        this.fields = fields;

        // look & fill
        this.skin = {
            className       : _.get(config,'skin.className','ui5-glist'),
            defaultAlignment: _.get(config,'skin.defaultAlignment',''),
            paddingLeft     : _.get(config,'skin.paddingLeft',0),   // left padding for glist in parent container (first-column width)
            paddingRight    : _.get(config,'skin.paddingRight',0),  // right padding for glist in parent container (last-column width)
            maxWidth        : _.get(config,'skin.maxWidth',null),   // is used only in GLIST_WIDTH_MODE_AUTO mode, if not set then gd.layout.widthMain is used by default (method getMaxWidth())
        }

        this.skinName               = _.find(this.skin.className.split(' '), className=>_.includes(className, 'skin-'))

        // init properties
        this.canAddColumns          = _.get(config, 'canAddColumns', false);
        this.canAddCustomColumns    = _.get(config, 'canAddCustomColumns', false);
        this.canResizeColumns       = _.get(config, 'canResizeColumns', false);
        this.canDndColumns          = _.get(config, 'canDndColumns', false);
        this.canDndItems            = _.get(config, 'canDndItems', false);
        this.canSort                = _.get(config, 'canSort', false);
        // this.canEditItems           = _.get(config, 'canEditItems', false);

        // Initi glist width mode
        this.widthMode              = _.get(config, 'widthMode', GlistWidthMode.FIXED) as GlistWidthMode


        // if true - user can dnd columns in header
        this.canChangeColumnsOrder  = _.get(config,'canChangeColumnsOrder', false);

        // if true - render more for head columns
        this.headerMoreButton       = _.get(config, 'headerMoreButton', false);

        // default method for column fields value render (should be above columsn init)
        this.defaultRenderMethod = _.get(config, 'defaultRenderMethod','renderView')

        // contains links to all main components we need to access directly
        this.components = {
            main: null, // reference for main component
        }

        // ?
        this.noItemsMessage         = _.get(config, 'noItemsMessage', 'No items found')
        this.noItemsRenderComponent = _.get(config, 'noItemsRenderComponent', null)

        // title column modes
        // default - non sticky title
        // sticky - sticky title
        this.titleSticky            = _.get(config, 'titleSticky', false)

        // enable/disable title field colum order change
        this.titleColumnReorder     = _.get(config, 'titleColumnReorder', true)

        this.renderTitleComponent   = _.get(config, 'renderTitleComponent', GListDefaultTitleFieldComponent)
        this.renderCellComponent    = _.get(config, 'renderCellComponent', null)

        this.headerMode             = _.get(config, 'headerMode', GlistHeaderMode.DEFAULT);


        // init managers
        this.initDataManager();
        this.initManagers();
        this.initDndManagers();


        this.hasAggregation         = this.columns.haveAggregation

    }

    destructor() {
        if (this.columns.destructor) this.columns.destructor()
    }

    initDataManager() {
        this.data               = new DataManager(this);
    }

    initManagers() {
        this.groupBy            = this.config.groupBy ? new GroupByManager(this, this.config.groupBy) : null;
        // this.groupBy should be initialized before this.columns
        // because columns rely on this.groupBy while calculating combined width
        if (this.columns) this.columns.destructor()
        this.columns            = new ListColumnsManager(this, this.config.columns);
        this.filters            = new GList_Filters(this, this.config.filters, this.config.preFilters);
        this.search             = new SearchManager(this);
        this.sortBy             = new SortByManager(this, this.config.sortBy, this.config.sortByRequired);
        this.selection          = new SelectionManager(this);
    }

    initDndManagers() {
        this.headerDndManager = !!this.config.canDndColumns ? new DNDManager({
            visualHorizontalDivisions: 1,
            visualVerticalDivisions: 1,
        }) : null;

        this.dndManager = !!this.config.canDndItems ? new DNDManager({
            visualHorizontalDivisions: 1,
            visualVerticalDivisions: 1,
        }) : null;
    }

    exportSettings():GListSettings {
        return _.omit({
            skinName: this.skinName,
            columns : this.columns.toJSON(),
            groupBy : (this.groupBy) ? this.groupBy.toJSON() : undefined,
            filters : this.filters.toJSON(),
            sortBy  : this.sortBy.toJSON()
        })
    }

    resetView(fields:FieldsCollection, config:GlistConfig) {
        if (fields) this.fields = fields;
        if (config) this.config = config;

        // if any changes reInit managers
        if (fields || config)  {
            this.initManagers();
            this.data.process();
        }

        this.reRender();
    }

    setSkin(value:string) {
        this.skin.className = _.replace(this.skin.className, this.skinName, value)
        this.skinName = value

        this.reRender()
    }

    setParentWidth(value:number) {
        debug && console.log(debug, "setParentWidth", value)

        this.parentWidth = value
        this.onWidthChanged(true)
    }

    getMaxWidth() {
        if (this.skin.maxWidth) return this.skin.maxWidth
        if (this.parentWidth)   return this.parentWidth - gd.layout.scrollWidth

        return gd.layout.widthMain - gd.layout.scrollWidth // complex calculations or double render are required to detect vertical scroll so just assume it always present
    }

    getConfig() {
        return {}
    }

    /* INTERFACE METHODS should be overridden */
    onSortByChanged() {}
    onToggleGroup() {}
    onFiltersChanged() {}
    onGroupByChanged() {}
    onColumnsChanged() {}

    onFieldValueChanged(field:FieldProto, model:any, newValue:any) {
        console.log(field, model, newValue);
        console.error("Not implemented #40343")
    }

    registerComponent(component:any) {
        this.components.main = component;
    }

    onItemClick(id:ID, data: any) {
        // should be overridden
    }

    setDragInProgress = (value:boolean) => {
        const node = findDOMNode(this.components.main);
        if (!node) return;

        if (value)  { // @ts-ignore
            node.classList.add('dnd-in-progress');
        }
        else        { // @ts-ignore
            node.classList.remove('dnd-in-progress');
        }
    }

    addCustomField(field:FieldProto) {
        // should be overridden
    }

    onWidthChanged(force = false) {
        // if width mode is GLIST_WIDTH_AUTO
        // and maxWidth is not of static value
        // then columns calculation and rerender is required
        if (force || (this.widthMode === GlistWidthMode.AUTO && !this.skin.maxWidth)) {
            this.columns.calculateCombinedWidth()
            this.reRender()
        }
    }

    /** GROUP HOVER [START] **/
    //required for title show over one of groups
    setGroupHover(groupId:string) {
        this.groupHoverId = groupId
        gd.bus.triggerEvent('g-list:group-hover')
    }

    updateDefaultGroupHover() {
        // if grouped and
        // if no groupHoverId select first not collapsed group
        if (this.groupBy?.value && !this.groupHoverId) {
            _.some(this.data.get(), group=>{
                const isCollapsed = this.groupBy?.isCollapsed(group.groupByValue)

                // if subGroup is not collapsed then set group hover id to show its header on first render
                if (!isCollapsed) this.setGroupHover(group.groupByValue)
                return !!this.groupHoverId; // exit _.some loop if already set
            })
        }
    }

    isGroupHovered(groupValue:string) {
        return this.groupHoverId === groupValue
    }
    /** GROUP HOVER [END] **/

    reRender = () => {

        // * In some cases there is not main component ... i.e. we have group by in app constrols
        // but no glist componenet (no records) to prevent error we add if here (vic feb 2022)
        if (!this.components.main) return

        this.components.main.forceUpdate();
        // the only difference between setState and forceUpdate is that setState subsequently
        // calls shouldComponentUpdate() and may prevent render if nothing changed (state or props)
        // and forceUpdate do not call shouldComponentUpdate and simply rerender component
    }
}


/***
 aggregate !! ???


 .fields (class)
 .fieldTypes {}
 .nameField = title / name

 .columns {}
 .currentFields - info o current fields we displ
 + width


 variant A
 .groupBy = FIELD_NAME
 .setGroupBy() {
 *ACTION HERE* ...
					<LIST>.reRender
					<APPCONTROLS>.<GROUPBY>.render() // gdbus ?
			}

 variant B
 .groupBy = class
 .field = FIELD NAME

 setGroupBy() {
					this.field = FIELD
 *ACTION HERE* ...
						<LIST>.reRender
						<APPCONTROLS>.<GROUPBY>.render() // gdbus ?
				}

 variant C
 ._groupBy = FIELD
 getter groupBy

 .actions = {
				setGroupBy() {
					this.manager._groupBy = FIELD
					RENDER...
				}

			}

 ***/
